import React, {useMemo} from 'react';
import '../style/Section3.scss';
import SectionTitle from "../components/SectionTitle";
import marketImg from '../assets/images/pc/02_Gotomarket.png';
import marketImg1Mobile from '../assets/images/mobile/02_Gotomarket_1.png';
import marketImg2Mobile from '../assets/images/mobile/02_Gotomarket_2.png';
import marketImg3Mobile from '../assets/images/mobile/02_Gotomarket_3.png';
import album1 from "../assets/images/pc/02_Gotomarket_2.png"
import album2 from "../assets/images/pc/02_Gotomarket_3.png"
import album3 from "../assets/images/pc/02_Gotomarket_4.png"
import album4 from "../assets/images/pc/02_Gotomarket_5.png"
import useWindowDimensions from "../util/Utils";
function Section3(props) {

  const { width } = useWindowDimensions();
  const isMobile = useMemo(() => {
    return width <= 780;
  }, [width]);

  return (
      <div id={'Section3'}>
        <SectionTitle title={'GO TO MARKET'}/>
        <div className="content-wrapper">
          <div className="description-wrapper">
            <div className="description-row margin-bottom">
              We are developing a comprehensive toolkit of essential features that you should expect from a Layer 1
              blockchain, including:
            </div>
            <div className="description-row"><strong>⦁ Simple yet robust node and validator setup/management</strong></div>
            <div className="description-row"><strong>⦁ A decentralized exchange</strong></div>
            <div className="description-row"><strong>⦁ A blockchain explorer</strong></div>
            <div className="description-row"><strong>⦁ No-code DApp builder</strong></div>
            <div className="description-row"><strong>⦁ Secure mobile wallet and messenger</strong></div>
            <div className="description-row margin-top">In addition, we incentivize builders on VERIA by sharing transaction fees with the wallets, nodes, and smart contracts involved in each transaction.</div>
            <div className="description-row margin-top">Most importantly, we leverage our marketing strength to individually promote every project built on VERIA. In other words, we share our distribution channels with our builders.</div>
            <div className="description-row margin-top">Currently we are actively recruiting <strong>GameFi, Memecoins, NFTs, and DeFi</strong> to VERIA</div>
          </div>
          {
            isMobile ?
                <div className='market-img-wrapper'>
                  <img src={marketImg2Mobile} alt="" className="market-img"/>
                  <img src={marketImg1Mobile} alt="" className="market-img"/>
                  <img src={marketImg3Mobile} alt="" className="market-img"/>
                </div>
                :
                <img src={marketImg} alt="" className="market-img"/>
          }
        </div>
        <div className="album-wrapper">
          <img src={album1} alt="" className="album-img"/>
          <img src={album2} alt="" className="album-img"/>
          <img src={album3} alt="" className="album-img"/>
          <img src={album4} alt="" className="album-img"/>
        </div>
      </div>
  );
}

export default Section3;